import React, { useContext, useEffect, useState } from "react";
import { AUTH_OTP, CATEGORY_SUBSCRIBER } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { BookSessionContext } from "@context/BookSessionContext";
import { PromoContext } from "@context/PromoContext";
import AlertMessage from "@components/AlertMessage";

const BookSessionMessage = () => {
    const [checkoutMessage, setCheckoutMessage] = useState("");

    const { whiteLabel } = useContext(ApplicationContext);

    const {
        selectedItems,
        promoCodeMessage,
        error,
        errorList,
        success,
    } = useContext(BookSessionContext);

    const { selectedPromo } = useContext(PromoContext);

    const isOtpAuth = whiteLabel?.subscriber_group?.authentication_type === AUTH_OTP;
    // For OTP we show "next", for free ticket promo (sub/stnd) we show "continue", for adv promo we show "checkout"
    const checkoutText = isOtpAuth ? "Next" : (
        selectedPromo?.promo_category === CATEGORY_SUBSCRIBER ? "Continue" : "Checkout"
    );

    const totalTicketQuantity = selectedItems.reduce((acc, cur) => {
        return cur.type === "ticket" ? acc + cur.quantity : acc;
    }, 0);

    const availableRedemptions = selectedPromo?.tickets_available > 0;

    useEffect(() => {
        if (isOtpAuth ||
            (
                selectedPromo &&
                !success &&
                totalTicketQuantity > 0
            )
        ) {
            setCheckoutMessage(
                (isOtpAuth && availableRedemptions)
                    ? "Click Next to apply complimentary tickets"
                    : `Click '${checkoutText}' to proceed with purchase`
            );
        } else if (success) {
            setCheckoutMessage(promoCodeMessage);
        }
    }, [availableRedemptions, selectedItems]);

    return (
        <>
            {checkoutMessage && (
                <div className="v3-booking__promo-code-msg v3-booking__promo-code-msg--success">
                    {checkoutMessage}
                </div>
            )}

            <div className="form__group-wrapper">
                {error && (
                    <AlertMessage
                        message={error}
                        messageList={errorList?.length ? errorList : null}
                        type="error"
                    />
                )}
            </div>
        </>
    );
};

export default BookSessionMessage;
